export const isObject = (data?: unknown): boolean => {
  const type = typeof data
  return type === 'function' || (type === 'object' && !!data)
}
